import { Icon24Resolve } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '../../types/SvgComponent';

const CheckMarkCircleIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 17L14 20L21 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CheckMarkCircleIcon = fplIcon(CheckMarkCircleIconLocal, Icon24Resolve);
